import {
  PRINT_LABEL_PRINT_DONE,
  PRINT_LABEL_PRINT_ERROR,
  PRINT_LABEL_PRINT_INPROGRESS,
} from '../constants/constant_saga_types';

const INIT_STATE = {
  isPrinting: false,
  error: {
    isError: false,
    message: ''
  }
};

export const labelPrintReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PRINT_LABEL_PRINT_DONE: {
      return { ...INIT_STATE };
    }

    case PRINT_LABEL_PRINT_INPROGRESS: {
      return { ...INIT_STATE, isPrinting: true };
    }

    case PRINT_LABEL_PRINT_ERROR: {
      const { message } = action.payload;
      return { ...INIT_STATE, error: { isError: true, message } };
    }

    default: {
      return state;
    }
  }
};
